import Rest from '../Rest';

export default class TokenService extends Rest {

    static resource = '/tokens';
    
    async createAPIkey(type) {
	
		return await this.post(`/`, type);

    }

    async getAPIkey() {

        const filter = [{property:'type',operator:'=',value:'api',}];
	
		return await this.get(`/?filter=${JSON.stringify(filter)}`);

    }
    
}